import { Toggle as KitToggle } from "@/components/kit";

// Adapter: single source of truth is kit's Toggle. Preserves this module's
// legacy API ({ checked, onChange, testid }) where onChange is a bare handler.
export function Toggle({ checked, onChange, testid }) {
  return <KitToggle checked={checked} onChange={() => onChange && onChange()} data-testid={testid} />;
}
